import { useEffect } from 'react';
import { TRACKERS } from '../lib/consultSource';

const ctaText = (a) => (a.getAttribute('data-cta') || a.textContent || a.getAttribute('aria-label') || a.title || '').replace(/\s+/g, ' ').trim();

// Tags every click on a link to /consultation or /quote with the current page and the clicked CTA text.
export const ConsultLinkTracker = () => {
  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest?.('a[href]');
      if (!a) return;
      let url;
      try { url = new URL(a.href, window.location.href); } catch { return; }
      if (url.origin !== window.location.origin) return;
      const t = TRACKERS.find((x) => url.pathname.replace(/\/+$/, '') === x.path);
      if (!t || window.location.pathname.replace(/\/+$/, '') === t.path) return;
      a.setAttribute('href', t.mark(ctaText(a)));
    };
    ['click', 'auxclick', 'contextmenu'].forEach((t) => document.addEventListener(t, onClick, true));
    return () => ['click', 'auxclick', 'contextmenu'].forEach((t) => document.removeEventListener(t, onClick, true));
  }, []);
  return null;
};
